<template>
  <aside>
    <span
      @click="langSelection">
        {{langSelected}}
        
      <ul
        class="language-list" 
        v-show="selection">
        <li
          :class="{'hidden' : lang === $i18n.locale}"
          v-for="(lang, i) in langs"
          :key="`Lang${i}`"
          @click.stop="setLang($event, lang)">
          
            <p>{{lang}}</p> 
        </li>
      </ul>
      </span>
    <!--
      Activate fo Accessibility 
      <select 
        v-if="false"
        v-model="langSelected">
        <option value=""></option>
        <option v-for="(lang, i) in langs" 
          :key="`Lang${i}`" :value="lang">
        /option>
        </select> 
      -->
  </aside>
</template>

<script>

  export default {
    name: 'language-selector',
    props: ['value'],
    data () {
      return { 
        // TODO - verify and activate translations
        // langs: ['en', 'it', 'fr', 'nl'],
        langs: ['en', 'it'],
        langSelected: this.$i18n.locale,
        selection: false
      }
    },
    // watch: {
    //   value() {
    //     this.langSelected = this.$i18n.locale
    //   }
    // },
    methods: {
      setLang(e, lang) {
        this.langSelected = lang;
        this.$i18n.locale = this.langSelected
        localStorage.setItem('user-lang', this.langSelected)
        this.closeSelection()
      },
      langSelection: function() {
        this.selection = !this.selection
      },
      closeSelection() {
        this.selection = !this.selection
      },
      appear(el, done) {
        this.tweenIn( el, done );
      },
      enter (el, done) {
        this.tweenIn( el, done );
      },
      leave(el, done) {
        this.tweenOut( el, done )
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../styles/_mixins.scss';

aside {
  span {
    cursor: pointer;
    position: relative;

    &:hover {
      border-bottom: 3px solid $secondary;
    }
  }
}

ul {
  position: absolute;
  padding-left: 0;
  list-style-type: none;
  padding: $small_vmin;
  border-top: 3px solid $secondary;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 120%);
  z-index: $z_index_max;
  background: white;
  @include border-radius;

  li {
    cursor: pointer;
    margin-bottom: 10px;
      border-bottom: 3px dashed transparent;
    transition: border-bottom .15s ease-in;

    &:hover {
      border-bottom: 3px dashed $secondary;
    }
  }
}
  
  // aside {
  //   align-self: end;
  //   z-index: $z_index_max;

  //   > span {
  //     display: block;
  //     position: relative;
      
  //     .language-list {
  //       position: absolute;
  //       padding-left: 0;
  //       padding: 3vmin;
  //       margin: 0;
  //       top: 0;
  //       right: 0;
  //       list-style-type: none;
  //       align-items: center;
  //       margin: 0;
  //       text-align: center;
  //       text-transform: uppercase;
  //       font-weight: 700;
  //       z-index: $z-index_max;
  //       @include center-content(column);

  //       li {
  //         min-width: 63px;
  //         border-radius: 50%;
  //         // background: $accent_2;
  //         margin-left: 2vmin;
  //         margin-bottom: 2vmin;

  //         &:first-child {
  //           margin-top: 5vw;
  //         }
  //         svg {
  //         margin-top: 20px;
  //         }

  //         &.hidden {
  //           display: none;
  //         }
  //       }
  //     }
  //   }
  // }
</style>
